import React from 'react';

import { BaseOrderView } from 'views/BaseOrderView';

export const DefaultOrderView: React.FC = () => <BaseOrderView />;
